import React from 'react';
import PropTypes from 'prop-types';
import { isNumeric, isUuid, createCustomPropType } from '../../../js/app/react/validators';
import { ESTATE_FLOW, GET_TITLE } from './ExplanationsConst';
import { LONGEVITY_ANALYSIS, SOCIAL_SECURITY } from '../Retirement/RetirementConstants';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { Tab, TabList, Tabs } from '../../CommonComponents/OPL/Tab';

const ExplanationsView = ({
  sections,
  goalId,
  clientId,
  recommendationTitle,
  selectedSection,
  setSelectedSection,
  noTabs,
  recommendationMessage,
}) => {
  return (
    <section
      style={{
        ...(selectedSection === LONGEVITY_ANALYSIS
          ? {
              marginBottom: '0',
              borderBottomLeftRadius: '0',
              borderBottomRightRadius: '0',
            }
          : {}),
      }}
      className={
        noTabs
          ? 'financial-plan-explanations-section-no-tabs'
          : 'financial-plan-explanations-section'
      }
    >
      {!noTabs && (
        <Tabs
          selectedIndex={sections.indexOf(selectedSection)}
          onSelect={index => setSelectedSection(goalId, sections[index], clientId)()}
        >
          <TabList px="20">
            {sections.map(section => (
              <Tab key={section}>{GET_TITLE(section)}</Tab>
            ))}
          </TabList>
        </Tabs>
      )}

      {selectedSection === SOCIAL_SECURITY && (
        <div className="recommendations-container">
          <Text fontWeight={600} color="neutral.600" fontSize="h4" lineHeight={1}>
            Social Security Comparative Analysis
          </Text>
          <p className="financial-plan-explanations-section-message">
            Compare Social Security filing options to determine which strategy fits best.
          </p>
        </div>
      )}

      {selectedSection !== ESTATE_FLOW &&
        selectedSection !== LONGEVITY_ANALYSIS &&
        selectedSection !== SOCIAL_SECURITY && (
          <div className="recommendations-container">
            <Text fontWeight={600} color="neutral.600" fontSize="h4" lineHeight={1}>
              {recommendationTitle}
            </Text>
            <p className="financial-plan-explanations-section-message">{recommendationMessage}</p>
          </div>
        )}
    </section>
  );
};

ExplanationsView.defaultProps = {
  selectedSection: null,
};

ExplanationsView.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.string).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  recommendationMessage: PropTypes.string.isRequired,
  recommendationTitle: PropTypes.string.isRequired,
  selectedSection: PropTypes.string,
  noTabs: PropTypes.bool.isRequired,
  setSelectedSection: PropTypes.func.isRequired,
};

export default ExplanationsView;
